module.exports = __webpack_public_path__ + "img/spotify.ab9c37f.svg";